import { render } from "./ProgressBarDATA.vue?vue&type=template&id=004586de"
import script from "./ProgressBarDATA.vue?vue&type=script&lang=js"
export * from "./ProgressBarDATA.vue?vue&type=script&lang=js"

import "./ProgressBarDATA.vue?vue&type=style&index=0&id=004586de&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__